import { useMemo } from 'react';
import { useMediaQuery } from 'react-responsive';
import { QUERY_DESKTOP_SIZE } from '@utils/constants';

interface ResponsiveLayout {
    isDesktop: boolean;
    isMobile: boolean;
}

/**
 * Helper returning a stateful object containing
 * the current screen width state : isMobile / isDesktop
 */
const useResponsiveLayout = (): ResponsiveLayout => {
    const isDesktop =
        useMediaQuery({ query: `(min-width: ${QUERY_DESKTOP_SIZE}px)` }) ||
        false;

    return useMemo(
        () => ({
            isDesktop,
            isMobile: !isDesktop,
        }),
        [isDesktop],
    );
};

export default useResponsiveLayout;
